// Hero section updated with a full black-to-transparent overlay and reduced height to fit within 100svh with the Onze werelden section.
// Updated: responsive gradient and content width — full width on mobile with a softer
//   wide overlay, 60% on desktop with the sharp left-to-black gradient.
// Updated: smaller mobile font sizes for title and description to fit within 100dvh.
// Updated: on mobile only the "Bekijk de collectie" CTA is shown, anchored to the hero's bottom-right.
// Updated: mobile content is narrower, positioned higher, and has more title-to-description spacing.

import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const heroContent = {
  title: 'Haagplanten, bomen en borderpakketten voor jouw tuin',
  description: 'Alles voor een groene buitenruimte, rechtstreeks van de kweker. Van sterke haagplanten en karaktervolle bomen tot complete borderpakketten, eenvoudig besteld en bij je thuisbezorgd.',
};

const Hero = () => {
  return (
    <section data-fast-scroll="viewed_hero" className="relative isolate h-[320px] overflow-hidden bg-black text-white sm:h-[340px] md:h-[380px]">
      <img
        src="/assets/sections/hero.webp"
        alt="Groene haagplanten van onze Dedemsvaartse kwekerij in het avondlicht"
        width={2000}
        height={800}
        fetchpriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div
        className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.9)_0%,rgba(0,0,0,0.6)_60%,rgba(0,0,0,0.25)_100%)] sm:bg-[linear-gradient(90deg,rgba(0,0,0,1)_0%,rgba(0,0,0,1)_30%,transparent_100%)]"
        aria-hidden="true"
      />

      <div className="relative mx-auto flex h-full max-w-7xl items-center px-6 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
          className="w-3/4 -translate-y-6 sm:w-3/5 sm:translate-y-0"
        >
          <h1 className="max-w-xl font-[Playfair_Display] text-[1.25rem] font-bold leading-[1.12] tracking-[-0.03em] text-white sm:text-[2.4rem] md:text-[2.7rem]">
            {heroContent.title}
          </h1>
          <p className="mt-4 max-w-lg text-[0.8rem] leading-relaxed text-white/80 sm:mt-4 sm:text-base">
            {heroContent.description}
          </p>
          <div className="mt-6 hidden sm:flex sm:flex-wrap sm:justify-start sm:gap-3">
            <a
              href="/assortiment"
              className="group inline-flex items-center gap-2 rounded-md bg-[#1e2b22] px-5 py-2.5 text-sm font-semibold text-white transition-[background-color,box-shadow] duration-300 hover:bg-[#304936] hover:ring-1 hover:ring-white hover:ring-offset-[2px] hover:ring-offset-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white focus-visible:ring-offset-2"
            >
              Bekijk de collectie
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" aria-hidden="true" />
            </a>
            <a
              href="/blogs"
              className="group hidden inline-flex items-center gap-2 rounded-md bg-white px-5 py-2.5 text-sm font-semibold text-[#1a1a1a] transition-colors duration-300 hover:bg-[#e7e1d6] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 sm:inline-flex"
            >
              Doe inspiratie op
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" aria-hidden="true" />
            </a>
          </div>
        </motion.div>

        <a
          href="/assortiment"
          className="absolute bottom-4 right-6 z-10 inline-flex items-center gap-2 rounded-md bg-[#1e2b22] px-5 py-2.5 text-sm font-semibold text-white transition-[background-color,box-shadow] duration-300 hover:bg-[#304936] hover:ring-1 hover:ring-white hover:ring-offset-[2px] hover:ring-offset-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white focus-visible:ring-offset-2 sm:hidden"
        >
          Bekijk de collectie
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
